import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { BaseFormService } from 'src/app/services/base-form.service';
import { GerenciarPermissoesService } from 'src/app/services/gerenciar-permissoes.service';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';

@Component({
    selector: 'app-gerenciar-permissoes-permissoes',
    templateUrl: './gerenciar-permissoes-permissoes.component.html',
    styleUrls: ['./gerenciar-permissoes-permissoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent]
})
export class GerenciarPermissoesPermissoesComponent extends BaseFormService implements OnInit {

  public itemsPerPage = 5;
  public currentPage = 1;
  public totalItems = 10;
  public aparecer: boolean = false;


  @Input() idContato: any;
  @Input() selectedAddressChild: number[] = [];

  public loadingGenerico: boolean = false;

  public listaPermissoes: any;
  public perfil: string;
  public perfilCheck: boolean = true;
  public descricao: any;
  public checkSelectAllClick: boolean[] = [];
  public checkSelectPermissionClick: boolean[] = [];
  public checkSelectAllClickSwich: boolean = false;
  public switchAll: boolean;
  public hifen: string = '';

  public erroSenha: boolean = false;

  public alertSucessoSubtitulo: any = 'Sucesso ao adicionar permissões !';
  public alertSucessoMensagem: any = 'Permissões adicionadas com sucesso.';

  public alertErroSubtitulo: any = 'Erro ao adicionar senha !';
  public alertErroMensagem: string = '';


  public alertSucesso: boolean = false;


  constructor(private readonly gerenciarPermissoesService: GerenciarPermissoesService) { super(); }

  ngOnInit(): void {
    this.getApiData();
  }

  public getApiData() {

    this.loadingGenerico = true;
    this.gerenciarPermissoesService.getPermissoes(this.idContato.id)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          this.listaPermissoes = success.response.map(item => {
            item.todosSelecionado = item.flagAlterar && item.flagIncluir && item.flagExcluir && item.flagImprimir;
            return item
          })
          this.switchAll = this.listaPermissoes.filter(linha => {

            return linha.flagAtivo;

          }).length == this.listaPermissoes.length
          this.setAllBoolean(this.listaPermissoes.length, false);
          this.setAllBoolean(this.checkSelectPermissionClick.length, false);


          for (const permissao of this.listaPermissoes) {
              if (permissao.menu) {
                  permissao.menu = permissao.menu + ' -';
              }
          }

          this.loadingGenerico = false;
          this.perfil = success.response[0].perfil;
          if (this.perfil == 'Filial') {
            this.perfilCheck = false;
          }
          if (this.perfil == 'Coordenação' || this.perfil == 'Analista' || this.perfil == '2a via') {
            this.perfilCheck = true;
          }

        }, error: () => {
          this.loadingGenerico = false;
        }
      });
  }

  salvarPermissoes() {

    this.addAddressBody();
    this.gerenciarPermissoesService.postpermissoes(this.listaPermissoes)
      .pipe(take(1))
      .subscribe({
        next: (success: any) => {
          if (success.status == 'OK') {
            this.alertSucesso = true;
          }
        }, error: () => {}
      });
  }

  permissoesTableClick(descricao, flagName, event: any) {
    let index = this.listaPermissoes.findIndex(x => x.descricao == descricao);

    if (index >= 0) {
      if (flagName == 'flagAtivo' && this.listaPermissoes[index].flagAtivo === true) {
        this.listaPermissoes[index]['flagAlterar'] = false;
        this.listaPermissoes[index]['flagIncluir'] = false;
        this.listaPermissoes[index]['flagExcluir'] = false;
        this.listaPermissoes[index]['flagImprimir'] = false;
      }
      this.listaPermissoes[index][flagName] = event.target.checked;
      this.listaPermissoes[index].todosSelecionado = this.listaPermissoes[index].flagAlterar && this.listaPermissoes[index].flagIncluir && this.listaPermissoes[index].flagExcluir && this.listaPermissoes[index].flagImprimir;
      this.switchAll = this.listaPermissoes.filter(linha => {

        return linha.flagAtivo;

      }).length == this.listaPermissoes.length
    }
  }

  selectAllPermissao(descricao, lineNumber, event: any) {

    let index = this.listaPermissoes.findIndex(x => x.descricao == descricao);

    //
    if (index >= 0 && event.target.checked === true) {
      this.listaPermissoes[index]['flagAlterar'] = true;
      this.listaPermissoes[index]['flagIncluir'] = true;
      this.listaPermissoes[index]['flagExcluir'] = true;
      this.listaPermissoes[index]['flagImprimir'] = true;
      this.listaPermissoes[index].todosSelecionado = true;
    }
    else {
      this.listaPermissoes[index]['flagAlterar'] = false;
      this.listaPermissoes[index]['flagIncluir'] = false;
      this.listaPermissoes[index]['flagExcluir'] = false;
      this.listaPermissoes[index]['flagImprimir'] = false;
      this.listaPermissoes[index].todosSelecionado = false;

    }

  }

  selectAll(event: any) {
    for (const permissao of this.listaPermissoes) {
        permissao.flagAtivo = event.target.checked;
        if (!event.target.checked) {
            permissao.flagAlterar = false;
            permissao.flagIncluir = false;
            permissao.flagExcluir = false;
            permissao.flagImprimir = false;
            permissao.todosSelecionado = false;
        }
    }

    this.checkSelectAllClickSwich = !this.checkSelectAllClickSwich;
  }

  public isCheckboxDisabled(index: number) {
    return (!this.listaPermissoes[index].flagAtivo)
  }

  public addAddressBody() {
      if (this.listaPermissoes.length > 0) {
          for (const permissao of this.listaPermissoes) {
              permissao.idEndereco = this.selectedAddressChild;
          }
      }
  }

  private setAllBoolean(size, value: boolean) {
    if (size > 0) {
      for (let i = 0; i < size; i++) {
        this.checkSelectAllClick.push(value);
        this.checkSelectPermissionClick.push(value);
      }
    }
  }

  public fecharAlertSucesso() {
    this.alertSucesso = false;
  }

  public fecharAlertErro() {
    this.erroSenha = false;
  }

}
